import * as types from '../actions/types';
import { SELECTED_SPACE } from '../features/spaces/constants';
const initialState = {
    reports: {
        WEEKLY: undefined,
        MONTHLY: undefined,
        YEARLY: undefined,
        INITIAL: undefined,
        PAYDAY: undefined,
    },
};
export class ReportParser {
    static INTERACTIVE_TYPES = new Set([
        'COIN_GRID',
        'EMMA_LIST_FRIENDS',
        'GUESS_WHICH_2X2',
        'QUEST_LIST',
        'QUEST_ITEM',
        'LAST_INITIAL',
        'LAST',
        'LAST_PAYDAY',
        'SPENDING_GROUP_DEBTS',
        'FREE_TRIAL',
        'REWARDS_LIST',
        'ORDERED_LIST',
        'SCRATCHCARD',
    ]);
    static INTERACTIVE_FRONTEND_CARD_TYPES = new Set(['UPGRADED_PREMIUM']);
    static MANUAL_START_CTA_TYPES = new Set([
        'QUEST_ITEM',
        'GAUGE_IMAGE',
        'SCRATCHCARD',
        'NEW_HOLDING',
        'LINE_GRAPH',
        'GRADIENT_LINE_GRAPH',
        'PREDICTION_LINE_GRAPH',
        'MULTI_LINE_GRAPH',
        'COMPARISON',
        'COUNTER',
    ]);
    static MANUAL_START_CONFETTI_TYPES = new Set(['GRADIENT_LINE_GRAPH']);
    static parse(report) {
        const items = report.items.map((item) => {
            const extra = {
                isInteractive: this.isInteractive(item),
                manualStartCTA: this.isManualStartCTA(item.type),
                manualStartConfetti: this.isManualStartConfetti(item.type),
            };
            const frontendItem = {
                ...item,
                ...extra,
                cta: this.parseCTA(item.cta),
            };
            return frontendItem;
        });
        return { ...report, items };
    }
    static parseCTA(cta) {
        if (cta?.appLink) {
            return { text: cta.text, type: 'appLink', appLink: cta.appLink };
        }
        if (cta?.url) {
            return { text: cta.text, type: 'url', url: cta.url };
        }
        return undefined;
    }
    static isInteractive(reportItem) {
        if (reportItem.type === 'FRONTEND') {
            const cardType = reportItem.cardType;
            return Boolean(cardType && this.INTERACTIVE_FRONTEND_CARD_TYPES.has(cardType));
        }
        return this.INTERACTIVE_TYPES.has(reportItem.type);
    }
    static isManualStartCTA(type) {
        return this.MANUAL_START_CTA_TYPES.has(type);
    }
    static isManualStartConfetti(type) {
        return this.MANUAL_START_CONFETTI_TYPES.has(type);
    }
}
const reports = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_REPORT_SUCCESS: {
            const parsedReport = ReportParser.parse(action.payload);
            return {
                ...state,
                reports: {
                    ...state.reports,
                    [action.payload.type]: parsedReport,
                },
            };
        }
        case SELECTED_SPACE:
        case types.LOGGED_OUT: {
            return initialState;
        }
        default:
            return state;
    }
};
export default reports;
